// Usage: v-tooltip:bottom.delayed="'Tooltip text'"
export default {
    beforeMount: function(el, binding){
        let delay = 0;
        if (binding.modifiers && binding.modifiers.delayed) {
            delay = { show: 1000, hide: 0 };
        }

        $(el).attr('data-toggle', 'tooltip')
            .attr('title', binding.value)
            .attr('data-placement', binding.arg)
            .tooltip({
                trigger: 'hover',
                delay: delay,
            });
    }
}
